export default {
  title: 'First Principle',
  sansFonts: ['Raleway', 'sans'],
  serifFonts: ['Roboto Slab', 'serif'],
  padding: '0.5rem',
  helloEmail: 'hello@fpinvestors.com',
  navLinkColorActive: 'black',
  navLinkColor: '#a8b3ba',
  whiteColor: '#fff',
  navToggleFontSize: 16,
  finePrintFontSize: '0.3rem'
}



// WEBPACK FOOTER //
// ./src/config.js